import { Injectable } from "@angular/core";
import { Setting } from "../setting";
import { BaseService } from "./base.services";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    public setting: Setting,
    public baseService: BaseService<any>
  ) {}

getUsers(filter:any): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService.get(`${this.setting.Endpoint.Users}?page=${filter.pageSize}&limit=${filter.rowsPerPage}`).subscribe({
            next: (response) => {
               resolve(response);
            },
            error: (error) => {
            }
        });
    })
    
    return promisse;
}

getSelectedPermissions(roleId: number): Promise<any> {
  let promisse = new Promise((resolve, reject) => {
    this.baseService.get(`${this.setting.Endpoint.Roles}/${roleId}/access`).subscribe({
          next: (response) => {
             resolve(response);
          },
          error: (error) => {
            reject(error);
          }
      });
  })
  
  return promisse;
}

createUser(user:any): Promise<any> {
  let promisse = new Promise((resolve, reject) => {
    this.baseService.post(this.setting.Endpoint.UsersWithOrganization,user).subscribe({
          next: (response) => {
             resolve(response);
          },
          error: (error) => {
            reject(error);
          }
      });
  })
  
  return promisse;
}

updateUser(id:number,user:any): Promise<any> {
  let promisse = new Promise((resolve, reject) => {
    this.baseService.put(`${this.setting.Endpoint.Users}/${id}`,user).subscribe({
          next: (response) => {
             resolve(response);
          },
          error: (error) => {
            reject(error);
          }
      });
  })
  
  return promisse;
}

getSalesRepresentatives(): Promise<any> {
  let promisse = new Promise((resolve, reject) => {
    this.baseService.get(`${this.setting.Endpoint.Users}/sales-rep`).subscribe({
          next: (response) => {
             resolve(response);
          },
          error: (error) => {
            reject(error);
          }
      });
  })
  
  return promisse;
}
}


